// US States
import al from '../../../../../assets/flags/al.png';
import ak from '../../../../../assets/flags/ak.png';
import az from '../../../../../assets/flags/az.png';
import ar from '../../../../../assets/flags/ar.png';
import ca from '../../../../../assets/flags/ca.png';
import co from '../../../../../assets/flags/co.png';
import ct from '../../../../../assets/flags/ct.png';
import dc from '../../../../../assets/flags/dc.png';
import de from '../../../../../assets/flags/de.png';
import fl from '../../../../../assets/flags/fl.png';
import ga from '../../../../../assets/flags/ga.png';
import hi from '../../../../../assets/flags/hi.png';
import id from '../../../../../assets/flags/id.png';
import il from '../../../../../assets/flags/il.png';
import indiana from '../../../../../assets/flags/in.png';
import ia from '../../../../../assets/flags/ia.png';
import ks from '../../../../../assets/flags/ks.png';
import ky from '../../../../../assets/flags/ky.png';
import la from '../../../../../assets/flags/la.png';
import me from '../../../../../assets/flags/me.png';
import md from '../../../../../assets/flags/md.png';
import ma from '../../../../../assets/flags/ma.png';
import mi from '../../../../../assets/flags/mi.png';
import mn from '../../../../../assets/flags/mn.png';
import mn_old_1983_2024 from '../../../../../assets/flags/mn_old_1983_2024.png';
import ms from '../../../../../assets/flags/ms.png';
import mo from '../../../../../assets/flags/mo.png';
import mt from '../../../../../assets/flags/mt.png';
import ne from '../../../../../assets/flags/ne.png';
import nv from '../../../../../assets/flags/nv.png';
import nh from '../../../../../assets/flags/nh.png';
import nj from '../../../../../assets/flags/nj.png';
import nm from '../../../../../assets/flags/nm.png';
import ny from '../../../../../assets/flags/ny.png';
import nc from '../../../../../assets/flags/nc.png';
import nd from '../../../../../assets/flags/nd.png';
import oh from '../../../../../assets/flags/oh.png';
import ok from '../../../../../assets/flags/ok.png';
import or from '../../../../../assets/flags/or.png';
import pa from '../../../../../assets/flags/pa.png';
import ri from '../../../../../assets/flags/ri.png';
import sc from '../../../../../assets/flags/sc.png';
import sd from '../../../../../assets/flags/sd.png';
import tn from '../../../../../assets/flags/tn.png';
import tx from '../../../../../assets/flags/tx.png';
import ut from '../../../../../assets/flags/ut.png';
import ut_old_2011_2024 from '../../../../../assets/flags/ut_old_2011_2024.png';
import vt from '../../../../../assets/flags/vt.png';
import va from '../../../../../assets/flags/va.png';
import wa from '../../../../../assets/flags/wa.png';
import wv from '../../../../../assets/flags/wv.png';
import wi from '../../../../../assets/flags/wi.png';
import wy from '../../../../../assets/flags/wy.png';

// US Territories
import american_samoa from '../../../../../assets/flags/american_samoa.png';
import guam from '../../../../../assets/flags/guam.png';
import nmi from '../../../../../assets/flags/nmi.png';
import pr from '../../../../../assets/flags/pr.png';
import usvi from '../../../../../assets/flags/usvi.png';

// Canadian Provinces and Territories
import ab from '../../../../../assets/flags/ab.png';
import bc from '../../../../../assets/flags/bc.png';
import mb from '../../../../../assets/flags/mb.png';
import nb from '../../../../../assets/flags/nb.png';
import nl from '../../../../../assets/flags/nl.png';
import ns from '../../../../../assets/flags/ns.png';
import nt from '../../../../../assets/flags/nt.png';
import nu from '../../../../../assets/flags/nu.png';
import on from '../../../../../assets/flags/on.png';
import pe from '../../../../../assets/flags/pe.png';
import qc from '../../../../../assets/flags/qc.png';
import sk from '../../../../../assets/flags/sk.png';
import yt from '../../../../../assets/flags/yk.png';

// Mexico
import ags from '../../../../../assets/flags/mexico/ag.png';
import bc_mex from '../../../../../assets/flags/mexico/bc.png';
import bcs from '../../../../../assets/flags/mexico/bs.png';
import camp from '../../../../../assets/flags/mexico/cm.png';
import chis from '../../../../../assets/flags/mexico/cs.png';
import cdmx from '../../../../../assets/flags/mexico/mx.png';
import coah from '../../../../../assets/flags/mexico/ch.png';
import col from '../../../../../assets/flags/mexico/cl.png';
import dgo from '../../../../../assets/flags/mexico/dg.png';
import gto from '../../../../../assets/flags/mexico/gj.png';
import gro from '../../../../../assets/flags/mexico/ge.png';
import hgo from '../../../../../assets/flags/mexico/hd.png';
import jal from '../../../../../assets/flags/mexico/ja.png';
import edomex from '../../../../../assets/flags/mexico/em.png';
import mich from '../../../../../assets/flags/mexico/mc.png';
import mor from '../../../../../assets/flags/mexico/mo.png';
import nay from '../../../../../assets/flags/mexico/na.png';
import nl_mex from '../../../../../assets/flags/mexico/nl.png';
import oax from '../../../../../assets/flags/mexico/oa.png';
import pue from '../../../../../assets/flags/mexico/pu.png';
import qro from '../../../../../assets/flags/mexico/qe.png';
import qroo from '../../../../../assets/flags/mexico/qi.png';
import slp from '../../../../../assets/flags/mexico/sl.png';
import sin from '../../../../../assets/flags/mexico/si.png';
import son from '../../../../../assets/flags/mexico/so.png';
import tab from '../../../../../assets/flags/mexico/tb.png';
import tamps from '../../../../../assets/flags/mexico/ta.png';
import tlax from '../../../../../assets/flags/mexico/tl.png';
import ver from '../../../../../assets/flags/mexico/vc.png';
import yuc from '../../../../../assets/flags/mexico/yu.png';
import zac from '../../../../../assets/flags/mexico/za.png';

export const US_FLAGS = [al, ak, az, ar, ca, co, ct, de, fl, ga, hi, id, il, indiana, ia, ks, ky, la, me, md, ma, mi, mn, mn_old_1983_2024,
    ms, mo, mt, ne, nv, nh, nj, nm, ny, nc, nd, oh, ok, or, pa, ri, sc, sd, tn, tx, ut, ut_old_2011_2024, vt, va, wa, wv, wi, wy,
    ab, bc, mb, nb, nl, ns, nt, nu, on, pe, qc, sk, yt,
    ags, bc_mex, bcs, camp, chis, cdmx, coah, col, dgo, gto,
    hgo, jal, edomex, mich, mor, nay, nl_mex, oax, pue, qro, qroo,
    slp, sin, son, tab, tamps, tlax, ver, yuc, zac,
    american_samoa, guam, nmi, pr, usvi, gro, dc];

export const REGION_TO_US_FLAGS = [
    [2],   // ARIZONA (index 0)
    [3],   // ARKANSAS (index 1)
    [4],   // CALIFORNIA (index 2)
    [5],   // COLORADO (index 3)
    [6],   // CONNECTICUT (index 4)
    [9],   // GEORGIA (index 5)
    [10],  // HAWAII (index 6)
    [12],  // ILLINOIS (index 7)
    [13],  // INDIANA (index 8)
    [17],  // LOUISIANA (index 9)
    [22, 23],  // MINNESOTA (index 10)
    [24],  // MISSISSIPPI (index 11)
    [26],  // MONTANA (index 12)
    [31],  // NEW_MEXICO (index 13)
    [34],  // NORTH_DAKOTA (index 14)
    [36],  // OKLAHOMA (index 15)
    [38],  // PENNSYLVANIA (index 16)
    [42],  // TENNESSEE (index 17)
    [47],  // VIRGINIA (index 18)
    [91],    // PUERTO_RICO (index 19)
    [7],   // DELAWARE (index 20)
    [49],  // WEST_VIRGINIA (index 21)
    [50],  // WISCONSIN (index 22)
    [51],  // WYOMING (index 23)
    [0],   // ALABAMA (index 24)
    [1],   // ALASKA (index 25)
    [8],   // FLORIDA (index 26)
    [11],  // IDAHO (index 27)
    [15],  // KANSAS (index 28)
    [30],  // NEW_JERSEY (index 29)
    [33],  // NORTH_CAROLINA (index 30)
    [40],  // SOUTH_CAROLINA (index 31)
    [48],  // WASHINGTON (index 32)
    [46],  // VERMONT (index 33)
    [44, 45],  // UTAH (index 34)
    [14],  // IOWA (index 35)
    [16],  // KENTUCKY (index 36)
    [18],  // MAINE (index 37)
    [20],  // MASSACHUSETTS (index 38)
    [21],  // MICHIGAN (index 39)
    [25],  // MISSOURI (index 40)
    [27],  // NEBRASKA (index 41)
    [28],  // NEVADA (index 42)
    [29],  // NEW_HAMPSHIRE (index 43)
    [32],  // NEW_YORK (index 44)
    [35],  // OHIO (index 45)
    [37],  // OREGON (index 46)
    [39],  // RHODE_ISLAND (index 47)
    [41],  // SOUTH_DAKOTA (index 48)
    [43],  // TEXAS (index 49)
    [94],    // DISTRICT_OF_COLUMBIA (index 50)
    [19],  // MARYLAND (index 51)
    [88],  // MEXICO_STATE_NAMES.SONORA (index 52)
    [66],  // MEXICO_STATE_NAMES.BAJA_CALIFORNIA (index 53)
    [],  // MEXICO_STATE_NAMES.CHIHUAHUA (index 54) - Not in the abbreviation list
    [71],  // MEXICO_STATE_NAMES.COAHUILA (index 55)
    [90],  // MEXICO_STATE_NAMES.TAMAULIPAS (index 56)
    [81],  // MEXICO_STATE_NAMES.NUEVO_LEON (index 57)
    [85],  // MEXICO_STATE_NAMES.QUINTANA_ROO (index 58)
    [68],  // MEXICO_STATE_NAMES.CAMPECHE (index 59)
    [89],  // MEXICO_STATE_NAMES.TABASCO (index 60)
    [69],  // MEXICO_STATE_NAMES.CHIAPAS (index 61)
    [72],  // MEXICO_STATE_NAMES.COLIMA (index 62)
    [79],  // MEXICO_STATE_NAMES.NAYARIT (index 63)
    [67],  // MEXICO_STATE_NAMES.BAJA_CALIFORNIA_SUR (index 64)
    [87],  // MEXICO_STATE_NAMES.SINALOA (index 65)
    [93],  // MEXICO_STATE_NAMES.YUCATAN (index 66)
    [92],  // MEXICO_STATE_NAMES.VERACRUZ (index 67)
    [76],  // MEXICO_STATE_NAMES.JALISCO (index 68)
    [77],  // MEXICO_STATE_NAMES.MICHOACAN (index 69)
    [93],  // MEXICO_STATE_NAMES.GUERRERO (index 70) - Not in the abbreviation list
    [82],  // MEXICO_STATE_NAMES.OAXACA (index 71)
    [77],  // MEXICO_STATE_NAMES.ESTADO_DE_MEXICO (index 72)
    [83],  // MEXICO_STATE_NAMES.PUEBLA (index 73)
    [78],  // MEXICO_STATE_NAMES.MORELOS (index 74)
    [84],  // MEXICO_STATE_NAMES.QUERETARO (index 75)
    [75],  // MEXICO_STATE_NAMES.HIDALGO (index 76)
    [74],  // MEXICO_STATE_NAMES.GUANAJUATO (index 77)
    [86],  // MEXICO_STATE_NAMES.SAN_LUIS_POTOSI (index 78)
    [94],  // MEXICO_STATE_NAMES.ZACATECAS (index 79)
    [65],  // MEXICO_STATE_NAMES.AGUASCALIENTES (index 80)
    [73],  // MEXICO_STATE_NAMES.DURANGO (index 81)
    [91],  // MEXICO_STATE_NAMES.TLAXCALA (index 82)
    [70],  // MEXICO_STATE_NAMES.CIUDAD_DE_MEXICO (index 83)
    [57],  // CANADA_PROVINCE_NAMES.NOVA_SCOTIA (index 84)
    [62],  // CANADA_PROVINCE_NAMES.QUEBEC (index 85)
    [54],  // CANADA_PROVINCE_NAMES.MANITOBA (index 86)
    [63],  // CANADA_PROVINCE_NAMES.SASKATCHEWAN (index 87)
    [52],  // CANADA_PROVINCE_NAMES.ALBERTA (index 88)
    [58],  // CANADA_PROVINCE_NAMES.NORTHWEST_TERRITORIES (index 89)
    [61],  // CANADA_PROVINCE_NAMES.PRINCE_EDWARD_ISLAND (index 90)
    [56],  // CANADA_PROVINCE_NAMES.NEWFOUNDLAND_AND_LABRADOR (index 91)
    [55],  // CANADA_PROVINCE_NAMES.NEW_BRUNSWICK (index 92)
    [64],  // CANADA_PROVINCE_NAMES.YUKON (index 93)
    [59],  // CANADA_PROVINCE_NAMES.NUNAVUT (index 94)
    [53],  // CANADA_PROVINCE_NAMES.BRITISH_COLUMBIA (index 95)
    [60],  // CANADA_PROVINCE_NAMES.ONTARIO (index 96)
    [88],    // TERRITORY_NAMES.AMERICAN_SAMOA (index 97)
    [90],    // TERRITORY_NAMES.NORTHERN_MARIANA_ISLANDS (index 98)
    [89],    // TERRITORY_NAMES.GUAM (index 99)
    [92]     // TERRITORY_NAMES.US_VIRGIN_ISLANDS (index 100)
];

export const US_FLAGS_TO_YEARS = [
    null, // al (0)
    null, // ak (1)
    null, // az (2)
    null, // ar (3)
    null, // ca (4)
    null, // co (5)
    null, // ct (6)
    null, // de (7)
    null, // fl (8)
    null, // ga (9)
    null, // hi (10)
    null, // id (11)
    null, // il (12)
    null, // indiana (13)
    null, // ia (14)
    null, // ks (15)
    null, // ky (16)
    null, // la (17)
    null, // me (18)
    null, // md (19)
    null, // ma (20)
    null, // mi (21)
    null, // mn (22)
    [1983, 2024], // mn_old_1983_2024 (23)
    null, // ms (24)
    null, // mo (25)
    null, // mt (26)
    null, // ne (27)
    null, // nv (28)
    null, // nh (29)
    null, // nj (30)
    null, // nm (31)
    null, // ny (32)
    null, // nc (33)
    null, // nd (34)
    null, // oh (35)
    null, // ok (36)
    null, // or (37)
    null, // pa (38)
    null, // ri (39)
    null, // sc (40)
    null, // sd (41)
    null, // tn (42)
    null, // tx (43)
    null, // ut (44)
    [2011, 2024], // ut_old_2011_2024 (45)
    null, // vt (46)
    null, // va (47)
    null, // wa (48)
    null, // wv (49)
    null, // wi (50)
    null, // wy (51)
    null, // ab (52)
    null, // bc (53)
    null, // mb (54)
    null, // nb (55)
    null, // nl (56)
    null, // ns (57)
    null, // nt (58)
    null, // nu (59)
    null, // on (60)
    null, // pe (61)
    null, // qc (62)
    null, // sk (63)
    null, // yt (64)
    null, // ags (65)
    null, // bc_mex (66)
    null, // bcs (67)
    null, // camp (68)
    null, // chis (69)
    null, // cdmx (70)
    null, // coah (71)
    null, // col (72)
    null, // dgo (73)
    null, // gto (74)
    null, // hgo (75)
    null, // jal (76)
    null, // edomex (77)
    null, // mich (78)
    null, // mor (79)
    null, // nay (80)
    null, // nl_mex (81)
    null, // oax (82)
    null, // pue (83)
    null, // qro (84)
    null, // qroo (85)
    null, // slp (86)
    null, // sin (87)
    null, // son (88)
    null, // tab (89)
    null, // tamps (90)
    null, // tlax (91)
    null, // ver (92)
    null, // yuc (93)
    null, // zac (94)
    null, // american_samoa (95)
    null, // guam (96)
    null, // nmi (97)
    null, // pr (98)
    null, // usvi (99)
    null, // gro (100)
    null  // dc (101)
];